import React from 'react';
import {StyledRentTypeTag} from "./RentTypeTag.styled";

const RentTypeTag = ({title} : any) => {
    return (
        <StyledRentTypeTag>{title}</StyledRentTypeTag>
    );
};

export default RentTypeTag;
